import { useLayoutEffect } from "react";

type ScrollLockTarget = "body" | HTMLElement | null;

export const useScrollLock = (
    locked: boolean,
    target: ScrollLockTarget = "body"
) => {
    useLayoutEffect(() => {
        if (!locked) return;

        const el =
            target === "body"
                ? document.body
                : target instanceof HTMLElement
                    ? target
                    : null;

        if (!el) return;

        const originalOverflow = el.style.overflow;

        el.style.overflow = "hidden";

        return () => {
            el.style.overflow = originalOverflow;
        };
    }, [locked, target]);
};